<script>
import moment from "moment";
import "moment/locale/id";
import form from "@/functions/numberFormat";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "GenderDonutChart",
  components: {
    apexchart: VueApexCharts,
  },
  props: ["data"],
  data() {
    return {
      moment,
      form,
      display: false,
      series: [0, 0], // percentages
      rawData: [0, 0], // raw counts
      chartOptions: {
        chart: {
          type: "donut",
          width: "70%",
          height: 220,
          toolbar: { show: false },
        },
        labels: ["Men", "Women"],
        colors: ["rgba(52, 151, 249, 1)", "rgba(161, 86, 255, 1)"],
        legend: {
          position: "top",
          labels: {
            colors: "#333",
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val.toFixed(1) + "%";
          },
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            colors: ["#fff"],
          },
        },
        // tooltip: {
        //   y: {
        //     formatter: (value, { seriesIndex, w }) => {
        //       const raw = w.config.rawData
        //         ? w.config.rawData[seriesIndex]
        //         : value;
        //       return `${value.toFixed(1)}% (${raw.toLocaleString()})`;
        //     },
        //   },
        // },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { position: "bottom" },
            },
          },
        ],
      },
    };
  },
  mounted() {
    if (this.data) {
      this.getData(this.data);
    }
  },
  methods: {
    async getData(data) {
      let total = Number(data[0]) + Number(data[1]);
      this.rawData = [Number(data[0]), Number(data[1])];

      if (total > 0) {
        this.series = [
          Number(((data[0] / total) * 100).toFixed(1)),
          Number(((data[1] / total) * 100).toFixed(1)),
        ];
      } else {
        this.series = [0, 0];
      }

      // ✅ Make sure rawData is included for tooltip
      this.chartOptions = {
        ...this.chartOptions,
        rawData: this.rawData,
      };

      this.display = true;
    },
  },
  watch: {
    data(val) {
      if (val) {
        this.getData(val);
      }
    },
  },
};
</script>

<template>
  <div class="chart-container">
    <apexchart
      v-if="display"
      type="donut"
      height="180"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<style scoped>
.chart-container {
  width: 100%;
  height: 220px; /* make sure enough height for the donut */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
